export default "__VITE_ASSET__BNAmXYp$__"